import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys, theme } from "@clockwise/web-commons/src/styles/color.styles";

export const rangeAndDurationContainer: CSSProperties = {
  display: "flex",
  alignItems: "center",
  borderBottom: `1px solid ${greys.paleGrey}`,
  padding: "5px 0",
};

export const duration = {
  container: {
    display: "flex",
    alignItems: "center",
    marginLeft: -2,
  } as CSSProperties,
  icon: {
    color: theme.textSecondary,
    width: 16,
    height: 16,
    marginLeft: 2,
    marginRight: 10,
    flexShrink: 0,
  } as CSSProperties,
};

export const dateRangePicker: CSSProperties = {
  flexGrow: 2,
  maxWidth: 130,
};

export const underlineStyle: CSSProperties = {
  visibility: "hidden",
};
